const aaa = [
	{
		path: "approveList",
		component: () => import("@/views/refund/approve/list.vue"),
		meta:{title:'审批管理',keepAlive:true},
	},
	{
		path: "approveSee",
		component: () => import("@/views/refund/approve/see.vue"),
		meta:{title:'审批管理'},
	},
	{
		path: "setList",
		component: () => import("@/views/refund/set/list.vue"),
		meta:{title:'审批流程'},
	},
]
export default aaa;